import WrapperCardComponent from './WrapperCardComponent'

export default WrapperCardComponent
